import React, {useState, useEffect} from 'react';
import ImageCropper from "./ImageCropper";
import {
  isDefined,
  titleize,
  rectColors,
  IMAGE_WIDTH,
  IMAGE_HEIGHT
} from "../../utils/utils";


// Funzione che verifica se debba essere evidenziato sull'interfaccia grafica un rettangolo che mostra il dettaglio
// di un difetto rilevato su un'immagine di una carta
const highlightRect = (rect, selectedRect, onHoverRect, selectedDefect, onHoverDefect) => {
  if (isDefined(selectedDefect?.id) || isDefined(onHoverDefect?.id))
    return (selectedDefect?.id === rect.defect.id || (!isDefined(selectedDefect?.id) && onHoverDefect?.id === rect.defect.id));
  else
    return selectedRect?.id === rect.id || (!isDefined(selectedRect?.id) && onHoverRect?.id === rect.id);
}


const FlawsContainer = ({ flaw, side, onHoverRect, selectedRect, onHoverDefect, selectedDefect }) => {

  // SOLUZIONE 2
  // Funzione che ritorna le coordinate dei punti necessari per disegnare sull'interfaccia grafica la freccia che guida
  // l'utente verso il riquadro che lo aiuta a ispezionare meglio il dettaglio di un difetto evidenziato sull'immagine
  const arrowPoints = (rect) => {
    if (side === 'right') {
      const y1 = rect.y + rect.height / 2;
      const y3 = (IMAGE_HEIGHT - rect.height) / 2 + rect.height / 2;
      const y2 = Math.min(y1, y3);
      return [
        { x: 0, y: y1, width: (IMAGE_WIDTH - rect.width) / 4 + 2, height: 2 },
        { x: (IMAGE_WIDTH - rect.width) / 4, y: y2, width: 2, height: Math.abs(y3 - y1) },
        { x: (IMAGE_WIDTH - rect.width) / 4, y: y3, width: (IMAGE_WIDTH - rect.width) / 4 + 2, height: 2 }
      ];
    }
    else {
      const y1 = rect.y + rect.height / 2;
      const y3 = (IMAGE_HEIGHT - rect.height) / 2 + rect.height / 2;
      const y2 = Math.min(y1, y3);
      return [
        { x: IMAGE_WIDTH - ((IMAGE_WIDTH - rect.width) / 4), y: y1, width: (IMAGE_WIDTH - rect.width) / 4 + 2, height: 2 },
        { x: IMAGE_WIDTH - ((IMAGE_WIDTH - rect.width) / 4), y: y2, width: 2, height: Math.abs(y3 - y1) },
        { x: IMAGE_WIDTH - ((IMAGE_WIDTH - rect.width) / 2), y: y3, width: (IMAGE_WIDTH - rect.width) / 4 + 2, height: 2 }
      ];
    }
  }




  return <div
    style={{
      width: IMAGE_WIDTH,
      height: IMAGE_HEIGHT,
      position: 'relative'
    }}>
    {
      flaw.rectangles.map((rect, index) => {
        const colors = rectColors(rect);
        const highlight = highlightRect(rect, selectedRect, onHoverRect, selectedDefect, onHoverDefect)
        return <React.Fragment key={`rect_detail_${rect.id}`}>
          {/*SOLUZIONE 1*/}
          {/*<div*/}
          {/*  key={index}*/}
          {/*  className={`${highlight ? 'd-flex' : 'd-none'}`}*/}
          {/*  style={{*/}
          {/*    position: "absolute",*/}
          {/*    left: rect.x,*/}
          {/*    top: rect.y,*/}
          {/*    width: rect.width + 4,*/}
          {/*    height: rect.height + 4,*/}
          {/*    border: colors.border,*/}
          {/*    zIndex: 1300*/}
          {/*  }}>*/}
          {/*SOLUZIONE 2*/}
          <div
            key={index}
            className={`${highlight ? 'd-flex' : 'd-none'}`}
            style={{
              position: "absolute",
              left: (IMAGE_WIDTH - rect.width) / 2,
              top: (IMAGE_HEIGHT - rect.height) / 2,
              width: rect.width + 4,
              height: rect.height + 4,
              border: colors.border,
              zIndex: 1300
            }}>
            <div>
              <ImageCropper
                imageUrl={flaw.image_url}
                x={rect.x}
                y={rect.y}
                width={rect.width}
                height={rect.height}
              />
            </div>
          </div>

          {/*SOLUZIONE 1*/}
          {/*<div*/}
          {/*  className={`${highlight ? 'd-flex' : 'd-none'}`}*/}
          {/*  style={{*/}
          {/*    position: "absolute",*/}
          {/*      left: side === 'right' ? 0 : rect.x + rect.width,*/}
          {/*      top: rect.y + rect.height / 2,*/}
          {/*      width: side === 'right' ? rect.x : IMAGE_WIDTH - (rect.x + rect.width),*/}
          {/*      height: 2,*/}
          {/*      backgroundColor: colors.borderColor,*/}
          {/*      pointerEvents: "none",*/}
          {/*  }}>*/}
          {/*</div>*/}
          {/*SOLUZIONE 2*/}
          {
            arrowPoints(rect).map((arrow, index) => {
              return <div
                key={`rect_${rect.id}_arrow_${index}`}
                className={`${highlight ? 'd-flex' : 'd-none'}`}
                style={{
                  position: "absolute",
                  left: arrow.x,
                  top: arrow.y,
                  width: arrow.width,
                  height: arrow.height,
                  backgroundColor: colors.borderColor,
                  pointerEvents: "none"
                }}>
              </div>
            })
          }
        </React.Fragment>
      })
    }
  </div>
}


const ImageFlawsContainer = ({
   side,
   flaw,
   onHoverRect,
   setOnHoverRect,
   selectedRect,
   setSelectedRect,
   onHoverDefect,
   selectedDefect,
   setOnHoverDefect
}) => {


  return <div className="d-flex justify-content-center w-100 m-0 p-0">
    {
      side === 'left' &&
        <FlawsContainer
          flaw={flaw}
          side={side}
          onHoverRect={onHoverRect}
          selectedRect={selectedRect}
          onHoverDefect={onHoverDefect}
          selectedDefect={selectedDefect}
        />
    }

    <div id="image-container"
       style={{
         position: "relative",
         display: "inline-block",
         width: IMAGE_WIDTH,
         height: IMAGE_HEIGHT
       }}
    >
      <img
        src={flaw.image_url}
        alt="canvas"
        style={{ width: IMAGE_WIDTH, height: IMAGE_HEIGHT }}
      />

      {
        flaw.rectangles.map((rect, index) => {
          const colors = rectColors(rect);
          const highlight = highlightRect(rect, selectedRect, onHoverRect, selectedDefect, onHoverDefect);
          return <React.Fragment key={index}>
            <div
              style={{
                position: "absolute",
                left: rect.x,
                top: rect.y,
                width: rect.width,
                height: rect.height,
                border: highlight ? "2px dashed blue" : colors.border,
                backgroundColor: highlight ? "rgba(0, 0, 255, 0.2)" : colors.bg,
              }}
              className="d-flex cursor-pointer"
              onMouseOver={() => {
                setOnHoverRect(rect);
                setOnHoverDefect(null);
              }}
              // onMouseLeave={() => {
              //   setOnHoverRect(!isDefined(selectedRect?.id) ? null : onHoverRect);
              // }}
              // onClick={() => {
              //   setSelectedRect(selectedRect?.id === rect.id ? null : rect);
              // }}
            ></div>

            <div
              className={`${highlight ? 'd-flex' : 'd-none'}`}
              style={{
                position: "absolute",
                left: side === 'left' ? 0 : rect.x + rect.width,
                top: rect.y + rect.height / 2,
                width: side === 'left' ? rect.x : IMAGE_WIDTH - (rect.x + rect.width),
                height: 2,
                backgroundColor: colors.borderColor,
                pointerEvents: "none",
                zIndex: 1400
              }}>
            </div>
          </React.Fragment>
        })
      }
    </div>

    {
      side === 'right' &&
        <FlawsContainer
          flaw={flaw}
          side={side}
          onHoverRect={onHoverRect}
          selectedRect={selectedRect}
          onHoverDefect={onHoverDefect}
          selectedDefect={selectedDefect}
        />
    }
  </div>
}


const FlawsInspector = ({ defects, flaws }) => {

  const [onHoverRect, setOnHoverRect] = useState(null);
  const [selectedRect, setSelectedRect] = useState(null);
  const [onHoverDefect, setOnHoverDefect] = useState(null);
  const [selectedDefect, setSelectedDefect] = useState(null);
  const flawsByImage = flaws.filter(flaw => isDefined(flaw.image_url));
  let detectedDefectsIds = [ ...flaws.map(flaw => [ ...flaw.rectangles.map(rect => rect.defect.id)])].flat();
  const defectsToRender = defects.filter(defect => defect.detection_enabled || detectedDefectsIds.includes(defect.id))


  // Funzione che ritorna il valore associato al difetto corrente in corrispondenza di una certa chiave
  // e che va renderizzato a video
  const defectValueToRender = (key) => {
    if (isDefined(selectedDefect?.id) || isDefined(onHoverDefect?.id))
      return titleize(isDefined(selectedDefect?.id) ? selectedDefect[key] : onHoverDefect[key]).replaceAll('_', ', ');
    else
      return titleize((isDefined(selectedRect?.id) ? selectedRect.defect[key] : (isDefined(onHoverRect?.id) ? onHoverRect.defect[key] : 'Missing')).replaceAll('_', ', '));
  }


  // Funzione che verifica se uno dei possibili difetti debba essere evidenziato sull'interfaccia grafica
  const highlightDefect = (defect) => {
    if (isDefined(selectedDefect?.id) || isDefined(onHoverDefect?.id))
      return selectedDefect?.id === defect.id || (!isDefined(selectedDefect?.id) && onHoverDefect?.id === defect.id);
    else
      return selectedRect?.defect?.id === defect.id || (!isDefined(selectedRect?.defect?.id) && onHoverRect?.defect?.id === defect.id);
  }



  return <div className="d-block mx-3 font-jost">
    <div className="row mb-5">
      {
        flawsByImage.map((flaw, index) => {
          return <div key={`${flaw.image_type}_flaws_container`}
                      className={`col-${12 / flawsByImage.length} d-flex justify-content-center px-0`}>
            <ImageFlawsContainer
              side={index % 2 === 0 ? 'left' : 'right'}
              flaw={flaw}
              onHoverRect={onHoverRect}
              setOnHoverRect={setOnHoverRect}
              selectedRect={selectedRect}
              setSelectedRect={setSelectedRect}
              onHoverDefect={onHoverDefect}
              selectedDefect={selectedDefect}
              setSelectedDefect={setSelectedDefect}
              setOnHoverDefect={setOnHoverDefect}
            />
          </div>
        })
      }
    </div>

    <div className="row w-100">
      <div className="col-lg-1"></div>
      <div className="col-12 col-lg-10 d-block br-8px my-5 px-0 border-solid">
        <div className="d-flex flex-wrap justify-content-between">
          {
            defectsToRender.map((defect, index) => {
              return <div key={defect.name}
                className={`
                  py-4 px-3 cursor-pointer d-flex justify-content-center text-center
                  ${highlightDefect(defect) ? 'bg-aig-gradient color-white' + (index === 0 ? ' border-top-left-radius-8px' : (index === defects.length - 1 ? ' border-top-right-radius-8px' : '')) : ''}
                `}
                // SOLUZIONE 1
                // onMouseOver={() => {
                //   setOnHoverDefect(defect);
                //   setOnHoverRect(null);
                // }}
                // onMouseLeave={() => {
                //   setOnHoverDefect(!isDefined(selectedDefect?.id) ? null : onHoverDefect);
                // }}
                // onClick={() => {
                //   setSelectedDefect(selectedDefect?.id === defect.id ? null : defect);
                // }}
              >
                <div className="d-block text-center">
                  <img src={defect.icon_url} width="25" height="25" className="mr-2"></img>
                  <p className="my-0">
                    {titleize(defect.name).replaceAll('_', ' ')}
                  </p>
                </div>
              </div>
            })
          }
        </div>

        <div className="border-top-solid row m-auto">
          <div className="col-3 border-right-solid border-bottom-solid">
            <div className="d-block pl-2">
              <p className="mt-1">
                <span className="color-gray mr-2">
                  Origin
                </span>
              </p>
              <p>
                {defectValueToRender('origin')}
              </p>
            </div>
          </div>

          <div className="col-3 border-right-solid border-bottom-solid">
            <div className="d-block pl-2">
              <p className="mt-1">
                <span className="color-gray mr-2">
                  Weight
                </span>
              </p>
              <p>
                {defectValueToRender('weight')}
              </p>
            </div>
          </div>

          <div className="col-3 border-right-solid border-bottom-solid">
            <div className="d-block pl-2">
              <p className="mt-1">
                <span className="color-gray mr-2">
                  Region
                </span>
              </p>
              <p>
                {defectValueToRender('region')}
              </p>
            </div>
          </div>

          <div className="col-3 border-bottom-solid">
            <div className="d-block pl-2">
              <p className="mt-1">
                <span className="color-gray mr-2">
                  Extension
                </span>
              </p>
              <p>
                {defectValueToRender('extension')}
              </p>
            </div>
          </div>

          <div className="col-12">
            <div className="d-block pl-2">
              <p className="mt-1">
                <span className="color-gray mr-2">
                  Description
                </span>
              </p>
              <p>
                {defectValueToRender('description')}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-1"></div>
    </div>
  </div>
};

export default FlawsInspector;